document.addEventListener('DOMContentLoaded', async () => {
  const el = document.getElementById('listado-local');
  if (!el) return;

  const ruta = el.dataset.listado;
  if (!ruta) return;

  // Detectar idioma
  const lang = document.documentElement.lang;

  let prefix = "Café de especialidad en ";
  let basePath = "/pages/";

  if (lang.startsWith('en')) {
    prefix = "Specialty coffee in ";
    basePath = "/en/pages/";
  }

  if (lang.startsWith('fr')) {
    prefix = "Café de spécialité à ";
    basePath = "/fr/pages/";
  }

if (lang.startsWith('pt')) {
  prefix = "Café de especialidade em ";
  basePath = "/pt/pages/";
}

  try {
    const resp = await fetch(ruta);
    if (!resp.ok) throw new Error("No se pudo cargar el JSON");

    const data = await resp.json();

    el.innerHTML = `
      <ul class="municipios">
        ${data.municipios
          .map(m => `
            <li>
              <a href="${basePath}${m.slug}">
                ${prefix}${m.nombre}
              </a>
            </li>
          `)
          .join('')}
      </ul>
    `;
  } catch (e) {
    console.error("Error cargando listado local:", e);
    el.innerHTML = `<p>No se pudo cargar el listado de municipios.</p>`;
  }
});